export function debounce(fn, wait) {
    let timer;
    return function(...args) {
        if (timer) {
            clearTimeout(timer); // clear any pre-existing timer
        }
        const context = this; // get the current context
        timer = setTimeout(() => {
            fn.apply(context, args); // call the function if time expires
        }, wait);
    };
}

export function __t(text, fromLocale = false, fallback = '') {
    if (! text) return fallback;

    const isBrowser = 'undefined' !== typeof window;
    const language = isBrowser ? (localStorage.getItem('language') ?? navigator.language.split('-')[0]) : 'en';

    if (fromLocale) {
        if (! isBrowser) return fallback;

        const locale = JSON.parse(localStorage.getItem(`translations.${language}`) ?? '{}');

        return locale[text] && 0 < locale[text].length ? locale[text] : locale.en ?? fallback;
    }

    return text?.[language] && 0 < text?.[language].length ? text[language] : text.en ?? fallback;
}
